const PROMISE_TYPES_SUFIXES = {
  PENDING: '_PENDING',
  FULFILLED: '_FULFILLED',
  REJECTED: '_REJECTED',
};

export function generateTypes(namespace, types) {
  return types.reduce((typesObject, key) => ({
    ...typesObject, [key]: `${namespace}/${key}`,
  }), {});
}

export function generatePromiseTypes(types) {
  return types.reduce((promiseTypesObject, type) => {
    const key = type.split('/').slice(-1);
    return {
      ...promiseTypesObject,
      [key]: {
        PENDING: `${type}${PROMISE_TYPES_SUFIXES.PENDING}`,
        FULFILLED: `${type}${PROMISE_TYPES_SUFIXES.FULFILLED}`,
        REJECTED: `${type}${PROMISE_TYPES_SUFIXES.REJECTED}`,
      },
    };
  }, {});
}

export function isRejectedPromiseType(type) {
  return type.endsWith(PROMISE_TYPES_SUFIXES.REJECTED);
}
